import { render, staticRenderFns } from "./MaterialSnackbar.vue?vue&type=template&id=45008570&"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=ts&"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialSnackbar.vue?vue&type=style&index=0&id=45008570&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports